export default __webpack_public_path__ + "static/media/efecto-5.9fdd8e6b.webp";